import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	inputVariableChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600]),
		borderRadius: "3px",
		fontWeight: "bold",
		padding: "2px",
		lineHeight: theme.spacing(0.2),
		marginBottom: "4px",
		maxWidth: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		"& span": {
			padding: 0
		}
	}
}))

export default useStyles
